<template>
  <div class="scores-container">
    <!-- Total Financial Assets Card -->
    <div class="risk-score-card">
      <i class="fas fa-wallet risk-icon"></i>
      <span style="font-size: 1.2em;">
        Financial Assets: {{ totalFinancialAssetsCAD }}
        <span v-if="totalFinancialAssetsUSD > 0">
          | {{ totalFinancialAssetsUSD }}
        </span>
      </span>
      <button class="add-asset-button" @click="showAddAssetModal" aria-label="Add Asset">
        <i class="fas fa-plus">Add</i>
      </button>
    </div>



    <!-- Individual Financial Assets -->
    <div v-for="(asset, index) in assets" :key="index" class="score-item">
      <div class="card" >
        <div class="card-title">

          <h3>{{ asset.financial_institution }}</h3>
      
          <p>{{ asset.name }}</p>
        
          <div v-if="selectedAssetIndex !== index">
            <p>Balance: $ {{ asset.current_balance }} {{ asset.currency }}</p>
          </div>
          <div v-else>
            <input type="number" v-model="editableBalance" />
            <button class="update-button" @click.stop="updateAssetBalance(asset, index)">Update</button>
          </div> <i class="edit-icon fas fa-edit" @click="selectAssetForUpdate(asset, index)"></i>
      
        </div>  </div>
        <div>
       
      </div>
    </div>
  <br>
     <!-- Add Asset Button -->

  <!-- Add Asset Modal -->
  <div v-if="isAddingAsset" class="modal">
      <div class="modal-content">
        <span class="close" @click="isAddingAsset = false">&times;</span>
        <h3>Add New Asset</h3>
        
        <input type="text" v-model="newAsset.financial_institution" placeholder="Financial Institution" required>
        
        <select v-model="newAsset.asset_type" required>
          <option value="depository">Depository (Banking)</option>
          <option value="investment">Investment</option>
          <option value="employer_sponsored">Employer Sponsored</option>
          <option value="other">Other</option>
        </select>

        <select v-model="newAsset.asset_subtype">
    
    <template v-if="newAsset.asset_type === 'depository'">
        <option value="chequing">Chequing Account</option>
        <option value="savings">Savings Account</option>
        </template>

        <template v-if="newAsset.asset_type === 'investment'">
          <option value="cash">Cash Brokerage Account</option>
          <option value="margin">Margin Brokerage Account</option>
          <option value="RRSP">RRSP</option>
          <option value="FHSA">FHSA</option>
          <option value="TFSA">TFSA</option>
          <option value="RESP">RESP</option>
          <option value="LIF">LIF</option>
          <option value="LIRA">LIRA</option>
          <option value="RRIF">RRIF</option>
          <option value="LRIF">LRIF</option>
          <option value="LRSP">LRSP</option>
          <option value="PRIF">PRIF</option>
          <option value="RDSP">RDSP</option>
          <option value="RLIF">RLIF</option>
          <option value="RSU">RSU</option>
          <option value="profit_sharing">Profit Sharing</option>
    </template>
  

    <!-- Options for Employer Sponsored -->
    <template v-if="newAsset.asset_type === 'employer_sponsored'">
        <option value="RRSP">RRSP</option>
        <option value="FHSA">FHSA</option>
        <option value="TFSA">TFSA</option>
    </template>


    <template v-if="newAsset.asset_type === 'other'">
      <option value="Other">Other</option>
    </template>

</select>

        <input type="text" v-model="newAsset.name" placeholder="Name of Account" required>
        <input type="number" v-model="newAsset.current_balance" placeholder="Current Balance" required>
        
        <select v-model="newAsset.currency" required>
          <option value="CAD">CAD</option>
          <option value="USD">USD</option>
          <!-- Add other currencies as needed -->
        </select>

        <select v-model="newAsset.account_status">
          <option value="active">Active</option>
          <option value="closed">Closed</option>
          <option value="pending">Pending</option>
        </select>

        <input type="checkbox" v-model="newAsset.exclude_from_networth"> Exclude from Net Worth

    
        
        <button @click="addNewAsset">Save</button>
      </div>
    </div>
  </div><br>
</template>
  <script>
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      assets: [],
      selectedAssetIndex: null,
      editableBalance: 0,
      isAddingAsset: false,  // For showing/hiding the add asset modal
      newAsset: {
        financial_institution: '',
        asset_type: '',
        asset_subtype: '',
        name: '',
        current_balance: null,
        currency: 'CAD',  // Default value set to CAD
        account_status: 'active',  // Default value
        exclude_from_networth: false,
      },
      assetSubtypeChoices: {
  
        'chequing': 'Chequing Account',
        'savings': 'Savings Account',
    'cash': 'Cash Brokerage Account',
    'margin': 'Margin Brokerage Account',
    'crypto': 'Crypto',
    'FHSA': 'FHSA',
    'LIF': 'LIF',
    'LIRA': 'LIRA',
    'LRIF': 'LRIF',
    'LRSP': 'LRSP',
    'PRIF': 'PRIF',
    'profit_sharing': 'Profit Sharing',
    'RDSP': 'RDSP',
    'RESP': 'RESP',
    'RLIF': 'RLIF',
    'RRIF': 'RRIF',
    'RRSP': 'RRSP',
    'TFSA': 'TFSA',
     'RSU': 'RSU',
    'Other': 'Other',
    
      },
    };
  },
  
  
  computed: {
    totalFinancialAssetsUSD() {
      const totalUSD = this.assets.reduce((sum, asset) => {
        return asset.currency === 'USD' ? sum + parseFloat(asset.current_balance) : sum;
      }, 0);
      return `$${totalUSD.toFixed(2)} USD`; // Format as USD currency
    },
    totalFinancialAssetsCAD() {
      const totalCAD = this.assets.reduce((sum, asset) => {
        return asset.currency === 'CAD' ? sum + parseFloat(asset.current_balance) : sum;
      }, 0);
      return `$${totalCAD.toFixed(2)} CAD`; // Format as CAD currency
    }
  },
  methods: {
     getIconClass(assettype) {
     {
      switch (assettype) {
        case 'depository':
          return 'fas fa-piggy-bank'; // Class for depository assets
        case 'investment':
          return 'fas fa-chart-line'; // Class for investment assets
        case 'employer_sponsored':
          return 'fas fa-briefcase'; // Class for employer sponsored assets
   
      }
    }
  },
    async fetchAssets() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await fetch('https://api.riskypaws.com/frontoffice/api/assets/', {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        if (!response.ok) throw new Error('Network response was not ok');
        this.assets = await response.json();
      } catch (error) {
        console.error('Error fetching assets:', error);
      }
    },
    selectAssetForUpdate(asset, index) {
      this.selectedAssetIndex = index;
      this.editableBalance = asset.current_balance;
    },
    async updateAssetBalance(asset, index) {
      const updateUrl = `https://api.riskypaws.com/frontoffice/api/assets/${asset.id}/`;
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await fetch(updateUrl, {
          method: 'PUT',
          headers: { 
            'Content-Type': 'application/json',
            'X-Cognito-Sub': cognitoSub 
          },
          body: JSON.stringify({ ...asset, current_balance: this.editableBalance })
        });
        if (!response.ok) throw new Error('Network response was not ok');
        this.assets[index].current_balance = this.editableBalance;
        this.selectedAssetIndex = null; // Reset selection
      } catch (error) {
        console.error('Error updating asset:', error);
      }
    },
    showAddAssetModal() {
      this.isAddingAsset = true;
    },
    async addNewAsset() {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await fetch('https://api.riskypaws.com/frontoffice/api/assets/', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'X-Cognito-Sub': cognitoSub 
          },
          body: JSON.stringify(this.newAsset)
        });
        if (!response.ok) throw new Error('Network response was not ok');
        this.fetchAssets(); // Reload assets
        this.isAddingAsset = false; // Hide the form
      } catch (error) {
        console.error('Error adding new asset:', error);
      }
    },
  },

  created() {
    this.fetchAssets();
  },
};
</script>
<style scoped>
.scores-container {
  display: flex;
  flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
  justify-content: center; /* Centers items */
  align-items: center;
  width: 100%;
  border: 2px solid #4A148C;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;  
  background-color: white; 
}

.risk-score-card {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Aligns items to start and end */
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.risk-icon {
  margin-right: 10px;
  font-size: 30px;
}

.card {
  background-color: black;
  color: white;
  border-radius: 15px;
  padding: 20px;
  margin: 10px;
  width: 300px;
  height: 150px;
  transition: transform 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.edit-icon {
  font-size: 1.5em;
  color: white;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

button {
  background-color: #4A148C; 
  color: white;
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

button:hover {
  background-color: black;
}

@media (max-width: 768px) {
  .risk-score-card {
    flex-direction: column;
    align-items: flex-start;
  }

  .edit-icon {
    position: static;
    margin-left: auto; /* Aligns the edit icon to the right on smaller screens */
  }
}
</style>